const COOKIE_NAME = 'rizzpay_payer';
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 400;
const COOKIE_VALUE_PATTERN = /^rp_[a-f0-9]{32}$/;

const canUseDocument = (): boolean =>
  typeof document !== 'undefined';

const readCookie = (): string | null => {
  if (!canUseDocument()) {
    return null;
  }

  const cookie = document.cookie
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith(`${COOKIE_NAME}=`));

  if (!cookie) {
    return null;
  }

  const value = decodeURIComponent(cookie.slice(COOKIE_NAME.length + 1));
  return COOKIE_VALUE_PATTERN.test(value) ? value : null;
};

const writeCookie = (value: string): void => {
  if (!canUseDocument()) {
    return;
  }

  const secureFlag = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(value)}; Max-Age=${COOKIE_MAX_AGE_SECONDS}; Path=/; SameSite=Lax${secureFlag}`;
};

const randomHex = (byteCount: number): string => {
  const bytes = new Uint8Array(byteCount);
  if (typeof window !== 'undefined' && window.crypto?.getRandomValues) {
    window.crypto.getRandomValues(bytes);
  } else {
    for (let index = 0; index < bytes.length; index += 1) {
      bytes[index] = Math.floor(Math.random() * 256);
    }
  }

  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
};

class AnonymousPayerService {
  getOrCreate(): string | null {
    const existing = readCookie();
    if (existing) {
      return existing;
    }

    const created = `rp_${randomHex(16)}`;
    writeCookie(created);
    return created;
  }
}

export const anonymousPayerService = new AnonymousPayerService();
